import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import notification from "../../helpers/notification";

export default function DragAndDrop({
  uploadedFile = "",
  setUploadedFile = () => {},
}) {
  const { t } = useTranslation();
  const [uploadedImages, setUploadedImages] = useState([]); // for preview
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (uploadedFile == "") {
      setUploadedImages([]);
    }
  }, [uploadedFile]);

  // Drag and Drop
  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  // Select File
  const handleFileInputChange = (e) => {
    e.preventDefault();
    handleFiles(e.target.files);
  };

  const handleFiles = (files) => {
    let oversize = false;

    const validFiles = Array.from(files).filter((file) => {
      const fileSize = file.size / (1024 * 1024); // in MB
      if (fileSize > 50) {
        notification("warning", t("File size exceeds 50MB. Skipping."));
        oversize = true;
        return false;
      }
      return true;
    });

    if (oversize && fileInputRef.current) {
      fileInputRef.current.value = null; // Reset file input
    }

    const previews = validFiles
      .filter((file) => file.type.startsWith("image/"))
      .map((file) => URL.createObjectURL(file));

    setUploadedFile(validFiles); // Pass array to parent
    setUploadedImages(previews);
  };

  return (
    <div
      className="drag-drop"
      onClick={() => document.querySelector("input[type=file]").click()}
    >
      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        className="upload-div border p-4"
      >
        <div className="flex flex-row items-center gap-2">
          <div className="flex flex-col items-center">
            <div className="d-flex" style={{ alignItems: "center" }}>
              <div
                className="p-2"
                style={{
                  backgroundColor: "#F0F0F0", // light grey background
                  borderRadius: "10px",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "5px",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00043 17.75C8.59043 17.75 8.25043 17.41 8.25043 17V12.81L7.53043 13.53C7.24043 13.82 6.76043 13.82 6.47043 13.53C6.18043 13.24 6.18043 12.76 6.47043 12.47L8.47043 10.47C8.68043 10.26 9.01043 10.19 9.29043 10.31C9.57043 10.42 9.75043 10.7 9.75043 11V17C9.75043 17.41 9.41043 17.75 9.00043 17.75Z"
                    fill="#F92424"
                  />
                  <path
                    d="M11.0004 13.75C10.8104 13.75 10.6204 13.68 10.4704 13.53L8.47043 11.53C8.18043 11.24 8.18043 10.76 8.47043 10.47C8.76043 10.18 9.24043 10.18 9.53043 10.47L11.5304 12.47C11.8204 12.76 11.8204 13.24 11.5304 13.53C11.3804 13.68 11.1904 13.75 11.0004 13.75Z"
                    fill="#F92424"
                  />
                  <path
                    d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
                    fill="#F92424"
                  />
                  <path
                    d="M22 10.75H18C14.58 10.75 13.25 9.42 13.25 6V2C13.25 1.7 13.43 1.42 13.71 1.31C13.99 1.19 14.31 1.26 14.53 1.47L22.53 9.47C22.74 9.68 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.81V6C14.75 8.58 15.42 9.25 18 9.25H20.19L14.75 3.81Z"
                    fill="#F92424"
                  />
                </svg>
              </div>
              <p className="file-upload-text">
                <span className="text-danger">{t("Click to Upload")}</span>{" "}
                {t("or drag and drop")}
                <br />
                (Max. File Size: 50 MB)
              </p>
            </div>
          </div>

          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileInputChange}
            className="d-none"
            accept="*"
            multiple
          />
        </div>

        {uploadedFile.length > 0 && (
          <div className="text-center mt-2 grid grid-cols-2 gap-2">
            {uploadedFile.map((file, index) =>
              file?.type?.includes("image") && uploadedImages[index] ? (
                <img
                  key={index}
                  src={uploadedImages[index]}
                  height="150"
                  width="250"
                  alt={t("Uploaded File")}
                />
              ) : (
                <p key={index}>{file.name}</p>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}
